<template>
    <div class="right_one shadow" >
        <el-carousel trigger="click" height="440px" style="margin-left: 30px">
            <el-carousel-item >
                <img style="width: 300px;height: 410px;margin-top: 30px" src="../../assets/img/img_swiper/1.jpg">
            </el-carousel-item>
            <el-carousel-item >
                <img style="width: 300px;height: 410px;margin-top: 30px" src="../../assets/img/img_swiper/2.jpg">
            </el-carousel-item>
            <el-carousel-item >
                <img style="width: 300px;height: 410px;margin-top: 30px" src="../../assets/img/img_swiper/3.jpg">
            </el-carousel-item>
            <el-carousel-item >
                <img style="width: 300px;height: 410px;margin-top: 30px" src="../../assets/img/img_swiper/4.jpg">
            </el-carousel-item>

        </el-carousel>
    </div>
</template>

<script>
    export default {
        name: "wzlj_img_swiper"
    }
</script>

<style lang="less" scoped>
    .right_one{
        height: 470px ;

    }

</style>
